import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppCacheService, CoreService } from '@nibras/core';
import { BaseDestroyableComponent } from '@nibras/shared/components';

@Component({
  selector: 'app-view-file',
  template: ''
})
export class ViewFileComponent extends BaseDestroyableComponent implements OnInit {
  fileGUID: string;
  downloadStatus: boolean;

  constructor(
    activatedRoute: ActivatedRoute,
    private coreService: CoreService,
    private appCacheService: AppCacheService
  ) {
    super();

    this.fileGUID = activatedRoute.snapshot.params.fileGUID;
    this.downloadStatus = activatedRoute.snapshot.params.download;
  }

  ngOnInit() {
    this.appCacheService.toggleAppProgress(true);

    this.coreService
      .downloadFileForView(this.fileGUID, this.downloadStatus)
      .pipe(this.takeUntilDestroy())
      .subscribe((fileData: any) => {
        const fileUrl = URL.createObjectURL(fileData);
        window.open(fileUrl as string, '_self');
      });
  }
}
